export default {
  //get all SUPERADMIN_PAYMENTs
  GET_SUPERADMIN_PAYMENTS_REQUEST: "GET_SUPERADMIN_PAYMENTS_REQUEST",
  GET_SUPERADMIN_PAYMENTS_SUCCESS: "GET_SUPERADMIN_PAYMENTS_SUCCESS",
  GET_SUPERADMIN_PAYMENTS_FAIL: "GET_SUPERADMIN_PAYMENTS_FAIL",

  //edit SUPERADMIN_PAYMENTs
  EDIT_SUPERADMIN_PAYMENT_REQUEST: "EDIT_SUPERADMIN_PAYMENT_REQUEST",
  EDIT_SUPERADMIN_PAYMENT_SUCCESS: "EDIT_SUPERADMIN_PAYMENT_SUCCESS",
  EDIT_SUPERADMIN_PAYMENT_FAIL: "EDIT_SUPERADMIN_PAYMENT_FAIL",

  //create SUPERADMIN_PAYMENT
  CREATE_SUPERADMIN_PAYMENT_REQUEST: "CREATE_SUPERADMIN_PAYMENT_REQUEST",
  CREATE_SUPERADMIN_PAYMENT_SUCCESS: "CREATE_SUPERADMIN_PAYMENT_SUCCESS",
  CREATE_SUPERADMIN_PAYMENT_FAIL: "CREATE_SUPERADMIN_PAYMENT_FAIL",

  CREATE_VOUCHER_REQUEST: "CREATE_VOUCHER_REQUEST",
  CREATE_VOUCHER_SUCCESS: "CREATE_VOUCHER_SUCCESS",
  CREATE_VOUCHER_FAIL: "CREATE_VOUCHER_FAIL",

  DELETE_SUPERADMIN_PAYMENT_REQUEST: "DELETE_SUPERADMIN_PAYMENT_REQUEST",
  DELETE_SUPERADMIN_PAYMENT_SUCCESS: "DELETE_SUPERADMIN_PAYMENT_SUCCESS",
  DELETE_SUPERADMIN_PAYMENT_FAIL: "DELETE_SUPERADMIN_PAYMENT_FAIL",

  GET_SUPERADMIN_PAYMENT_REQUEST: "GET_SUPERADMIN_PAYMENT_REQUEST",
  GET_SUPERADMIN_PAYMENT_SUCCESS: "GET_SUPERADMIN_PAYMENT_SUCCESS",
  GET_SUPERADMIN_PAYMENT_FAIL: "GET_SUPERADMIN_PAYMENT_FAIL",

  GET_SUPERADMIN_PAYMENT_EXCEPTION_REQUEST:
    "GET_SUPERADMIN_PAYMENT_EXCEPTION_REQUEST",
  GET_SUPERADMIN_PAYMENT_EXCEPTION_SUCCESS:
    "GET_SUPERADMIN_PAYMENT_EXCEPTION_SUCCESS",
  GET_SUPERADMIN_PAYMENT_EXCEPTION_FAIL:
    "GET_SUPERADMIN_PAYMENT_EXCEPTION_FAIL",

  ADD_SUPERADMIN_PAYMENTS_LOADING: "ADD_SUPERADMIN_PAYMENTS_LOADING",
};
